function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from "styled-components";
import { Button } from "./Buttons";
const StyledContent = styled.div`
  padding-bottom: 2rem;
`;

class DeleteWarning extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_isMounted", false);

    _defineProperty(this, "renderWarning", () => {
      if (this._isMounted) {
        const {
          name,
          onDelete,
          buttonSize = 'sm',
          ...restProps
        } = this.props;
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledContent, null, "Deleting ", name, " is permanent.."), /*#__PURE__*/React.createElement(Button, _extends({
          onClick: onDelete
        }, restProps, {
          color: 'danger',
          size: buttonSize,
          cypress: 'deleteConfirm'
        }), "Delete"));
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null);
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderWarning());
    });
  }

  componentDidMount() {
    this._isMounted = true;
    this.forceUpdate();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

}

export default DeleteWarning;